import { render, staticRenderFns } from "./DataDaily.vue?vue&type=template&id=52191d4c"
import script from "./DataDaily.vue?vue&type=script&lang=js"
export * from "./DataDaily.vue?vue&type=script&lang=js"
import style0 from "./DataDaily.vue?vue&type=style&index=0&id=52191d4c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports